import React from "react";
import PropTypes from "prop-types";

const ArrowDashIcon = ({ height = "26", width = "26", viewBox = "0 0 26 26" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9999 4.74072C13.5522 4.74072 13.9999 5.18844 13.9999 5.74072L13.9999 20.2592C13.9999 20.8115 13.5522 21.2592 12.9999 21.2592C12.4477 21.2592 11.9999 20.8115 11.9999 20.2592L11.9999 5.74072C11.9999 5.18844 12.4477 4.74072 12.9999 4.74072Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9663 12.2929C21.3568 12.6834 21.3568 13.3166 20.9663 13.7071L13.7071 20.9664C13.3165 21.3569 12.6834 21.3569 12.2928 20.9664L5.03359 13.7071C4.64306 13.3166 4.64306 12.6834 5.03359 12.2929C5.42411 11.9024 6.05728 11.9024 6.4478 12.2929L13 18.845L19.5521 12.2929C19.9426 11.9024 20.5758 11.9024 20.9663 12.2929Z"
        fill="white"
      />
    </svg>
  );
};

ArrowDashIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  viewBox: PropTypes.string,
};

export default ArrowDashIcon;
